import React, { useContext, useState } from "react";
import MenuTool from "../../components/Toolnav/MenuTool";
import Training from "./components/Training";
import { AiOutlinePlus } from "react-icons/ai";
import AddTraining from "./components/AddTraining";
import { useQuery } from "@tanstack/react-query";
import { handleFetchTrainings } from "../../api/training";
import { AuthContext } from "../../contexts/AuthContext";

export default function AllTrainings() {
  const { auth } = useContext(AuthContext);
  const [createModal, setCreateModal] = useState<boolean>(false);
  const access = ["Admin", "Instructor"];
  const { data: trainings } = useQuery({
    queryKey: ["allTrainings"],
    queryFn: handleFetchTrainings,
  });
  return (
    <div className="">
      <MenuTool
        menus={[{ id: 1, name: "All Trainings", to: "/trainings" }]}
        actions={
          <>
            {access?.includes(auth?.role) && (
              <button
                onClick={() => setCreateModal(true)}
                className="flex justify-center items-center border py-1 px-4 bg-blue-100"
              >
                <AiOutlinePlus /> <span className="mx-1">Add</span>
              </button>
            )}
          </>
        }
      />
      <div className="p-2">
        {trainings?.payload?.map((training: any, index: number) => (
          <Training training={training} key={index} link="trainings" />
        ))}
      </div>

      <AddTraining
        isVisible={createModal}
        setVisible={setCreateModal}
        trainings={trainings?.payload}
      />
    </div>
  );
}
